/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActiveRoleRequest } from '../../models/active-role-request';
import { CaseResourceDto } from '../../models/case-resource-dto';

export interface GetActiveRole$Params {
      body: ActiveRoleRequest
}

export function getActiveRole(http: HttpClient, rootUrl: string, params: GetActiveRole$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseResourceDto>> {
  const rb = new RequestBuilder(rootUrl, getActiveRole.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseResourceDto>;
    })
  );
}

getActiveRole.PATH = '/case-resources/role/active';
